import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SUB_DIRECTORY } from "../../../../common/constant";
// import Blog from "../../../../component/blog";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import SocialMedia from "../../../../component/social_media";
import _ from 'lodash';
import InfromationCard from "../../../../component/information_card";
import CustomerFeedback from "../../../../component/customer_feedback";
import { actionReviews, resetReviewsResponse } from "./store";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../common/app_constant";
import Loader from "../../../../component/page_loader";

const Reviews = () => {

    const dispatch = useDispatch()
    const navigation = useNavigate()


    const { reviewsList } = useSelector((state) => ({
        ...state.reviewsStore
    }))

    const [isCustomerFeedback, setIsCustomerFeedback] = useState(false)
    const [reviewsArr, setReviewsArr] = useState([])
    const [isLoader, setIsLoader] = useState(true)


    useEffect(() => {
        dispatch(actionReviews())
    }, [])

    useEffect(() => {
        if (reviewsList !== null) {
            dispatch(resetReviewsResponse())
            if (reviewsList.result === true) {
                setIsLoader(false)
                setReviewsArr(reviewsList.data.reviews)
            } else {
                setIsLoader(false)
                switch (reviewsList.status) {
                    case 400:
                        toast.error(reviewsList.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [reviewsList])


    return (
        <>

            <div className="row py-5">
                <div className="col-12">
                    <nav
                        aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a onClick={() => {
                                // navigation('/dashboard')
                            }}>Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Reviews</li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12 col-md-8">
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            reviewsArr != null && reviewsArr.length > 0 ?
                                reviewsArr.map((item, index) => {
                                    return (
                                        <div className=" container">
                                            <div className=" row">
                                                <div className="d-flex mb-3 pb-2 border-bottom"></div>
                                                <div className=" px-5 col-md-12">
                                                    <i className="fa fa-quote-left" />
                                                    &nbsp;{item.content}
                                                    <i className="fa fa-quote-right" />
                                                    <p className="fw-bold mb-0 mt-3">
                                                        -<i>{item.name}</i>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <div className="d-flex justify-content-center align-items-center mt-5">
                                    <h5>No Reviews To Display</h5>
                                </div>
                    }

                </div>
                <div className="col-12 col-md-4">
                    <InfromationCard isMarginTop={false} />
                    <div class="mt-3">
                        <span class="fw-bold">feedback</span>
                        <div class="card mt-2 shadow p-2 d-flex cursor-pointer" data-bs-toggle="modal" data-bs-target="#customerfeedback">
                            <div onClick={() => {
                                setIsCustomerFeedback(true)
                            }}>
                                <img src={`${SUB_DIRECTORY}/assets/images/icon/megaphone.png`} class="img-fluid me-3" /> <b>Customer feedback</b>
                            </div>
                        </div>
                    </div>
                    {/* <Blog /> */}
                </div>
            </div>

            <CustomerFeedback
                isCustomerFeedback={isCustomerFeedback}
                feedbackClose={() => {
                    window.location.reload()
                    setIsCustomerFeedback(false)
                }}
            />
        </>

    )

}

export default Reviews;